<template>
  <div style="margin-top: 40px; padding-bottom: 20px">
    <h3 class="noPddingTitle font_bold">期望预估的日期区间生长性能</h3>
    <a-table
      :scroll="{ x: 500 }"
      :columns="columns"
      :data-source="list"
      class="nopaddingEstimateTable"
      :pagination="false"
      row-key="id"
    >
      <template v-for="el in fixedArr" :slot="el" slot-scope="text">
        <span :key="el">{{ text ? Number(text).toFixed(2) : "-" }}</span>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  expectationEstimationColumns,
  sucklingExpectationEstimationList,
} from "../../../../EstimateConfig/estimateConfig";
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  props: ["isAdd", "resId", "tabKey", "details"],
  data() {
    return {
      list: [],
      fixedArr: [],
      sectionList: [],
      estimateId: getRequest("id"),
      isRefresh: true,
      sucklingExpectationEstimationList,
      energySystemNameA: ''
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState('estimate',['energy']),
    columns() {
      let newColumns = this.dealColumns();
      return newColumns;
    },
  },
  watch: {
    resId(val) {
      this.isRefresh = true;
      this.getDetails(val);
    },
    tabKey() {
      if (this.resId && this.isRefresh) this.init(this.resId);
    },
  },
  methods: {
    dealColumns() {
      let newColumns = [...expectationEstimationColumns];
      this.sectionList.forEach((el, index) => {
        newColumns.push({
          title: el.name,
          dataIndex: `f${index + 1}`,
          children: [
            {
              title: "预估值",
              dataIndex: `${el.field}`,
              scopedSlots: { customRender: `${el.field}` },
              width: 120,
            },
          ],
        });
      });
      return newColumns;
    },
    init() {
      if (this.estimateId && this.isAdd) {
        this.getDetails(this.estimateId);
      } 
      else if (!this.isAdd && this.resId) {
        this.getDetails(this.resId);
      }
    },
    getDetails(id) {
      this.sectionList = [];
      this.list = [];
      if (!id) return;
      this.isRefresh = false;
      this.$http
        .get(
          `/sat-maximization/opweightrangeformula/subDetail?predictionId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            //动态生成头部区间
            let sectionList = [];
            data.forEach((el) => {
              sectionList.push({
                name: `${el.initialDayinput}-${el.finalDayinput}天`,
                field: `${el.initialDayinput}-${el.finalDayinput}`,
              });
              this.fixedArr.push(`${el.initialDayinput}-${el.finalDayinput}`);
            });

            //生成表格数据
            let list = []
            this.sucklingExpectationEstimationList && this.sucklingExpectationEstimationList.forEach((item) => {
              let obj = {
                name: item.startStr ? `${item.startStr}[${this.energy.name}]${item.endStr}` : item.name,
                unit: item.unit,
              };
              data.forEach((el) => {
                let dataBase = el.opWeightRangeFormula;
                obj[`${el.initialDayinput}-${el.finalDayinput}`] = dataBase[item.field];   
              });
              list.push(obj);
            });
            this.list = [...list]
            this.sectionList = [...sectionList]
          }
        });
    },
  },
};
</script>